import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { any } from 'underscore';
import * as moment from 'moment-timezone';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class Utils {
  DefaultTimeZone = 'America/New_York';
  constructor() { }
  pluralize(ret: any) {
    if (ret.substr(ret.length - 1, 1) === 'y') return ret.substr(0, ret.length - 1) + 'ies';
    else if (
      ret.substr(ret.length - 2, 2) === 'ss' ||
      ret.substr(ret.length - 2, 2) === 'as' ||
      ret.substr(ret.length - 2, 2) === 'us'
    )
      return ret + 'es';
    else return ret + 's';
  }

  initialUpper(str: string) {
    return str.substr(0, 1).toUpperCase() + str.substr(1);
  }

  sortByFieldInServer(colName: string, cols: any) {
    let isAsc = false;
    for (const col of cols) {
      if (col.name == colName) {
        if (col.isAsc) {
          col.isAsc = !col.isAsc;
        } else {
          col.isAsc = true;
        }
        isAsc = col.isAsc;
      } else {
        //remove isasc
        delete col.isAsc;
      }
    }
    return cols;
  }

  sortByField(colName: string, cols: any, data: any) {
    let isAsc = false;
    for (const col of cols) {
      if (col.name == colName) {
        if (col.isAsc) {
          col.isAsc = !col.isAsc;
        } else {
          col.isAsc = true;
        }
        isAsc = col.isAsc;
      } else {
        //remove isasc
        delete col.isAsc;
      }
    }
    return data.sort((a: any, b: any) => {
      const x = a[colName];
      const y = b[colName];
      if (isAsc) {
        return x < y ? -1 : x > y ? 1 : 0;
      } else return x > y ? -1 : x > y ? 1 : 0;
    });
  }

  formatDate(dt: any) {
    return new Date(dt).getMonth() + 1 + '/' + new Date(dt).getDate() + '/' + new Date(dt).getFullYear();
  }
  formatTime(time: any) {
    const minutes = Math.floor(time / 60),
      seconds = Math.round(time % 60);
    if (minutes > 90) return Math.round((time / 3600) * 10) / 10 + ' hours';
    else return (minutes > 0 || seconds == 0 ? minutes + ' min' : '') + (seconds > 0 ? ' ' + seconds + ' sec' : '');
  }

  formatTimeWithSeconds(dt: any, inclSeconds: any) {
    if (isNaN(dt)) return '0:00';

    let isPM = false,
      hour = dt.getHours(),
      min = dt.getMinutes(),
      seconds = dt.getSeconds();
    if (hour > 11) {
      isPM = true;
      if (hour > 12) hour = hour - 12;
    } else if (hour == 0) hour = 12;
    if (min < 10) min = '0' + min;
    if (seconds < 10) seconds = '0' + seconds;
    return hour + ':' + min + (inclSeconds ? ':' + seconds : '') + (isPM ? ' PM' : ' AM');
  }

  convertUTCDateToLocalDate(date: any) {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);
    return newDate.toLocaleString();
  }

  convertServerDate(date: any) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  }

  getFileExtension(filename: any) {
    //filename =(!_.isEmpty(filename))?filename:'';
    if (filename != undefined && filename != null) {
      let ext = filename.split('?')[0].split('.');
      ext = ext[ext.length - 1].toLowerCase();
      return ext;
    }
  }
  isValidDate(value) {
    if (value == null) return false;
    var dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(value)) {
      value = new Date(parseInt(value.replace("/Date(", "").replace(')/', "")));
    }
    let _date = new Date(value);
    let ans = (_date instanceof Date) && !isNaN(new Date(_date).getDate());
    return ans;
  }
  GetESTtoLocalTimeZone(obj: any) {
    //console.log('browserLanguage', this.browserLanguage);
    //console.log('Usertimezone', this.Usertimezone);  
    //console.log('Original', obj);
    let CurrentEst = obj;
    if (this.isValidDate(obj)) {
      CurrentEst = this.convertTZ(obj);
    }
    return this.formatDateTime(new Date(CurrentEst));
  }
  convertTZ(date) {
    // Check if a specific date/time falls within DST
    const CurrentEst = moment.tz(date, this.DefaultTimeZone);
    // const isDST = CurrentEst.isDST();
    // console.log(`Is ${date}  in DST for ${CurrentEst}? ${isDST}`); 
    return CurrentEst;
  }
  formatDateTime(dt: any, inclSeconds: any = 0, inclWeekDay: any = 0) {
    return (
      (inclWeekDay ? this.getDayOfWeek(dt) + ' ' : '') +
      this.formatDate(dt) +
      ' ' +
      this.formatTimeWithSeconds(dt, inclSeconds)
    );
  }
  getDayOfWeek(dt: any) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dt.getDay()];
  }

  formatDuration(duration, unit, includeHours, verbose, removeSeconds) {
    if (duration < 0) duration = 0;
    let totalSeconds,
      hours,
      minutes,
      seconds,
      output = '';
    switch (unit) {
      case 'ms':
      case 'millisecond':
      case 'milliseconds':
        totalSeconds = Math.round(duration / 1000);
        break;
      case 's':
      case 'sec':
      case 'second':
      case 'seconds':
      default:
        totalSeconds = duration;
        break;
      case 'm':
      case 'minute':
      case 'minutes':
        totalSeconds = duration * 60;
        break;
      case 'h':
      case 'hour':
      case 'hours':
        totalSeconds = duration * 3600;
        break;
    }
    const days = Math.floor(totalSeconds / 86400);
    totalSeconds = totalSeconds - days * 86400;
    hours = Math.floor(totalSeconds / 3600);
    totalSeconds = totalSeconds - hours * 3600;
    minutes = Math.floor(totalSeconds / 60);
    totalSeconds = totalSeconds - minutes * 60;
    seconds = Math.floor(totalSeconds);

    if (verbose)
      return (
        (days > 0 ? days + ' days ' : '') +
        (includeHours || hours > 0 ? hours + ' hr ' : '') +
        (minutes > 0 ? minutes + ' min ' : '') +
        (seconds > 0 && !removeSeconds ? seconds + ' sec' : '')
      );

    hours += days * 24;
    if (includeHours || hours > 0) output = hours + ':';
    output += (minutes < 10 ? '0' : '') + minutes;
    if (!removeSeconds) output += ':' + (seconds < 10 ? '0' : '') + seconds;
    return output;
  }
  getArrayIndex(array: any, search: any, propName: any) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  }

  getPopupWindow(name: any) {
    let popupWindow = null;
    if (typeof this.popupWindows == 'undefined') this.popupWindows = [];
    for (let i = 0; i < this.popupWindows.length; i++) {
      if (this.popupWindows[i].id == name) {
        popupWindow = this.popupWindows[i];
      }
    }
    return popupWindow;
  }

  /* Open a popup window */
  mainWindow: any;
  popupWindows: any;
  popup(options: any) {
    let listenersAdded = false;
    if (typeof this.mainWindow == 'undefined') this.mainWindow = window;
    if (typeof this.popupWindows == 'undefined') this.popupWindows = [];
    const popOpts = {
      width: 800,
      height: 500,
      scrollbars: 0,
      forceReload: false,
      name: 'popWin',
      url: options.url,
      //name: options.name
    };
    //$.extend(popOpts, options);

    let popFeatures = 'scrollbars=' + popOpts.scrollbars + ',resizable,status';
    let popupWindow = this.getPopupWindow(popOpts.name);
    const leftX = popupWindow ? popupWindow.lastLeft : null;
    const topY = popupWindow ? popupWindow.lastTop : null;
    const callbackCalled = false;

    if (popupWindow != null) {
      if (popupWindow.closed) {
        popFeatures +=
          ',width=' +
          (popupWindow.lastWidth || popOpts.width) +
          ',height=' +
          (popupWindow.lastHeight || popOpts.height) +
          ',';
        popFeatures += this.popupCentered(
          popupWindow.lastWidth || popOpts.width,
          popupWindow.lastHeight || popOpts.height,
          leftX,
          topY
        );
        popupWindow = window.open(popOpts.url, popOpts.name, popFeatures);
        for (let i = 0; i < this.popupWindows.length; i++) {
          if (this.popupWindows[i].id == popOpts.name) {
            this.popupWindows[i] = popupWindow;
          }
        }
      } else {
        if (popupWindow.location != popOpts.url && popOpts.url != 'about:blank') {
          popupWindow.resizeTo(popOpts.width, popOpts.height);
          popupWindow.location = popOpts.url;
        } else if (popOpts.forceReload) {
          popupWindow.resizeTo(popOpts.width, popOpts.height);
          popupWindow.location.reload(true);
        } else {
          listenersAdded = true;
        }
        // if (callback) callback();
        //  callbackCalled = true;
        popupWindow.focus();
      }
    } else {
      popFeatures +=
        ',width=' +
        popOpts.width +
        ',height=' +
        popOpts.height +
        ',' +
        this.popupCentered(popOpts.width, popOpts.height, 0, 0);
      popupWindow = window.open(popOpts.url, popOpts.name, popFeatures);
      this.popupWindows.push(popupWindow);
    }

    let windowCheckTimer: any = null;
    const windowIsReady = function () {
      window.clearTimeout(windowCheckTimer);
      if (popupWindow) {
        if (!listenersAdded) {
          //  popupWindow.addEventListener('unload',  ()=> { this.updateWindowPosSize() });
        }
        popupWindow.id = popOpts.name;
        //if (callback && !callbackCalled) callback();
        popupWindow.focus();
      } else {
        windowCheckTimer = window.setTimeout(windowIsReady, 100);
      }
    };

    windowIsReady();
    return popupWindow;
  }

  updateWindowPosSize(win: any) {
    win.lastWidth = win.innerWidth;
    win.lastHeight = win.innerHeight;
    win.lastLeft = win.screenX;
    win.lastTop = win.screenY;
  }

  /* Get screen coordinates to center popup based on its width and height */
  popupCentered(popupWidth: any, popupHeight: any, popupLeft: any, popupTop: any) {
    const indentMSIEWidth = 'left=' + (popupLeft || popupLeft === 0 ? popupLeft : this.popupIndent(popupWidth, false));
    const indentMSIEHeight = 'top=' + (popupTop || popupTop === 0 ? popupTop : this.popupIndent(popupHeight, true));
    const centerCoordinates = indentMSIEWidth + ',' + indentMSIEHeight;
    return centerCoordinates;
  }

  /* Get screen offset of popup */
  popupIndent = function (popupDimension: any, isHeight: any) {
    if (isHeight) {
      return (screen.availHeight - popupDimension) / 2 + screen.availHeight;
    } else {
      return (screen.availWidth - popupDimension) / 2 + screen.availWidth;
    }
  };

  static store(key, value) {
    localStorage.setItem(key, btoa(value));
  }

  static fetch(key) {
    return atob(localStorage.getItem(key));
  }

  static convertTime12to24(time12h: any) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}${minutes}`;
  }
  static convertTimes12to24(time12h: any) {
    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':');
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    hours = hours.toString().padStart(2, '0');
    return `${hours}${minutes}`;
  }

  static convertTo12HourFormat(time24Hour) {
    if (!Number.isInteger(time24Hour) || time24Hour < 0 || time24Hour >= 2400) {
      return 'Invalid input. Please provide a valid 24-hour time (e.g., 2300).';
    }
    let hours = Math.floor(time24Hour / 100);
    const minutes = time24Hour % 100;
    let amPm = 'AM';
    let convertedHours = hours;

    let period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    // if (hours >= 12) {
    //   amPm = 'PM';
    // } else if (hours === 0) {
    //   convertedHours = 12;
    // }
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;

    //return `${convertedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${amPm}`;
  }

  static formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  static convertSecondsToTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30); // Assuming 30 days per month
    const years = Math.floor(months / 12); // Assuming 12 months per year

    const timeComponents = {
      seconds: seconds % 60,
      minutes: minutes % 60,
      hours: hours % 24,
      days: days % 30,
      months: months % 12,
      years: years,
    };

    // Construct the formatted string
    let formattedTime = '';
    if (timeComponents.years > 0) {
      formattedTime += `${timeComponents.years} Years `;
    }
    if (timeComponents.months > 0) {
      formattedTime += `${timeComponents.months} Months `;
    }
    if (timeComponents.days > 0) {
      formattedTime += `${timeComponents.days} Days `;
    }
    if (timeComponents.hours > 0) {
      formattedTime += `${timeComponents.hours} Hours `;
    }
    if (timeComponents.minutes > 0) {
      formattedTime += `${timeComponents.minutes} Minutes `;
    }
    if (timeComponents.seconds > 0) {
      formattedTime += `${timeComponents.seconds.toFixed(0)} Seconds`;
    }

    return formattedTime.trim();
  }

  static convertDataURIToBinary(dataURI) {
    const BASE64_MARKER = ';base64,';
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    const base64 = dataURI.substring(base64Index);
    const raw = window.atob(base64);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  static toCamelCase(str) {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
  }

  static cleanString(value: string): string {
    if (value) {
      let decoded = value.replace(/&amp;/g, '&');
      decoded = decoded.replace(/&#(\d+);?/g, (_, code) =>
        String.fromCharCode(parseInt(code, 10))
      );
      decoded = decoded.replace(/[\n\t•]/g, ' ');
      return decoded.replace(/\s+/g, ' ').trim();
    }
    else {
      return '';
    }

  }

  /**
   * Decodes HTML entities in a string safely without XSS vulnerabilities.
   * SECURITY: Uses textContent instead of innerHTML to prevent script injection.
   * This method safely converts HTML entities (e.g., &amp; &lt; &gt;) to their character equivalents
   * without executing any embedded JavaScript or HTML tags.
   * 
   * @param encoded - String containing HTML entities to decode
   * @returns Decoded string with HTML entities converted to characters
   */
  static GetDecodedString(encoded: string): string {
    if (!encoded) {
      return encoded;
    }

    let decoded = encoded;
    let previous: string;

    do {
      previous = decoded;
      const txt = document.createElement('textarea');
      // SECURITY: Use textContent instead of innerHTML to prevent XSS attacks
      // textContent does not parse HTML tags or execute scripts
      txt.textContent = previous;
      decoded = txt.value;
    } while (decoded !== previous);

    return decoded;
  }

  static navigateToSalesForcePage(baseURL: { value: string }, CrmUserID: any, CrmCaseID: any): void {
    if (!CrmUserID) {
      // No CrmUserID, go to the account list
      baseURL.value += '/lightning/o/Account/list';
    } else if (CrmCaseID) {
      // Go straight to the case
      baseURL.value += `/lightning/r/Case/${CrmCaseID}/view?ws=%2Flightning%2Fr%2FAccount%2F${CrmUserID}%2Fview`;
    } else {
      // Go to the account
      baseURL.value += `/${CrmUserID}`;
    }
  }

  static extractPath(url) {
    const segments = new URL(url).pathname
        .split('/')
        .filter(Boolean);
    return segments.slice(2).join('/');
  }

  /**
   * Shared HTTP error handler for use with rxjs `catchError` in services.
   * - Unwraps Blob-typed error bodies (occurs when the request used responseType: 'blob')
   *   back into a usable HttpErrorResponse. See https://github.com/angular/angular/issues/19888
   * - Otherwise extracts a plain-string error message for callers to consume.
   *
   * Note: loader hiding, logging, and 401 redirect are already handled globally by
   * errorLoggingInterceptor; this helper only reshapes the error for call sites.
   */
  static handleHttpError(errorResponse: HttpErrorResponse) {
    let errorMessage = '';
    if (
      errorResponse instanceof HttpErrorResponse &&
      errorResponse.error instanceof Blob &&
      errorResponse.error.type === 'application/json'
    ) {
      return new Promise<any>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          try {
            const errmsg = JSON.parse((<any>e.target).result);
            reject(
              new HttpErrorResponse({
                error: errmsg,
                headers: errorResponse.headers,
                status: errorResponse.status,
                statusText: errorResponse.statusText,
              })
            );
          } catch (e) {
            reject(errorResponse);
          }
        };
        reader.onerror = e => {
          reject(errorResponse);
        };
        reader.readAsText(errorResponse.error);
      });
    } else if (errorResponse.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = errorResponse.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${errorResponse.status}\nMessage: ${errorResponse.message}`;
    }
    return throwError(() => errorMessage);
  }

}

export enum UserStatus {
  LOGGED_IN = 1,
  LOGGED_OUT,
  INVALID_LOGIN,
  INVALID_COMPANY,
  INVALID_PASSWORD,
  ACCESS_DENIED,
  IP_RESTRICTION,
  LOCKED_OUT,
  INVALID_ACCESS_KEY,
  USER_ALREADY_EXISTS,
  INVALID_SSO_LOGIN,
  CONCURRENTLIMIT_REACHED,
}
